import { select, call, put } from 'redux-saga/effects';
import { setAnalyticSubscriptionUsage } from '../../../../state/analytic/analyticSubscriptionUsageSlice';
import { selectUserCredentials } from '../../../../state/userCredential/userCredentialSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* fetchSubscriptionUsageSaga(action) {
    const { domain, uid } = yield select(selectUserCredentials);
    try {
        const { data } = yield call(
            [backendClient, backendClient.get],
            `usage/users/${encodeURIComponent(uid)}`
        );

        yield put(setAnalyticSubscriptionUsage({
            uid,
            domain,
            analytics: {
                enabled: data.analytics.enabled,
                overage: data.analytics.overage,
                quotaMinutes: data.analytics.quotaMinutes,
                usedMinutes: data.analytics.usedMinutes,
                remainingMinutes: data.analytics.remainingMinutes,
            },
            callAssistant: {
                enabled: data.callAssistant.enabled,
                overage: data.callAssistant.overage,
                quotaMinutes: data.callAssistant.quotaMinutes,
                usedMinutes: data.callAssistant.usedMinutes,
                remainingMinutes: data.callAssistant.remainingMinutes,
            },
            chatAssistant: {
                enabled: data.chatAssistant.enabled,
                overage: data.chatAssistant.overage,
                quotaCredits: data.chatAssistant.quotaCredits,
                usedCredits: data.chatAssistant.usedCredits,
                remainingCredits: data.chatAssistant.remainingCredits,
            },
        }));
    } catch (err) {
        const status = err?.response?.status;
        bugsnagClient.notify(err);
        console.error('Failed to fetch analytic subscription usage', status, err?.message);
    }
}
